import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/market-banner.png'
import _imports_1 from '@/assets/img/exchange-record.png'
import _imports_2 from '@/assets/img/market-list-btn.png'


const _hoisted_1 = { class: "market-wrapper" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "banner-img",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "number" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.textCount.surplus), 1),
      _createVNode("div", {
        class: "banner-btn btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRecordFu && _ctx.goRecordFu(...args)))
      }, [
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activityData.templateConfig.goods_list, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "list-item",
          key: index
        }, [
          _createVNode("img", {
            class: "pic",
            src: item.img
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", null, _toDisplayString(item.title), 1),
              _createVNode("div", null, "需福字:" + _toDisplayString(item.number) + "个", 1)
            ]),
            _createVNode("div", {
              class: "list-btn btn",
              onClick: ($event: any) => (_ctx.goDetail(index))
            }, [
              _hoisted_9
            ], 8, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}